<template>
  <div class="sidebar-inner">
    <!-- Top section -->
    <div class="top-section">
      <h4 v-if="!isLoadingMedia" class="mb-1">Media</h4>
      <h4 v-if="isLoadingMedia" class="mb-1">Loading Media...</h4>
      <hr>
      <!-- Is Loading -->
      <div class="text-center mt-4" v-if="isLoadingMedia">
        <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
      </div>
      <!-- / Is Loading -->

      <!-- Loaded -->
      <div v-if="!isLoadingMedia && media !== null">
        <div class="axum-data mt-3" v-if="media.length === 0">
          <div class="property-card">
            <b class="property-name text-danger">
              No media to show
            </b>
          </div>
        </div>
      </div>
      <!-- / Loaded -->

      <!-- Has Media -->
      <div v-if="!isLoadingMedia && media.length">
        <media v-for="file in media" :file="file" :key="file.id"></media>
      </div>
      <!-- / Has Media -->
    </div>
    <!-- / Top section -->
    <!-- Bottom section -->
    <div class="bottom-section pt-3 pb-3">
      <upload-media-modal @file-uploaded="loadMedia" :ticket-id="ticket.id"></upload-media-modal>
      <a href="#" @click.prevent="openUploadMediaModal" class="btn btn-itg-dark btn-block"
         :class="{'disabled': isLoadingMedia}">
        <i class="fa fa-plus mr-1"></i>
        Upload Media
      </a>
    </div>
    <!-- / Bottom section -->
  </div>
</template>

<script>
import Forms from "../../../../../mixins/Forms";
import Tickets from "../../../../../mixins/Tickets";
import UploadMediaModal from "../widgets/UploadMediaModal";
import Media from "../widgets/Media";
import {mapGetters, mapActions} from "vuex";

export default {
  name: "MediaSidebar",
  mixins: [Forms, Tickets],
  data() {
    return {}
  },
  created() {
    this.loadMedia();
  },
  components: {UploadMediaModal, Media},
  computed: {
    ...mapGetters('ticketViewer', {
      ticket: 'ticket',
      isLoadingMedia: 'isLoadingMedia',
      media: 'media'
    })
  },
  methods: {
    ...mapActions('ticketViewer', {
      loadMedia: 'loadMedia'
    }),

    openUploadMediaModal() {
      this.$bvModal.show('upload-media-modal');
    }
  }
}
</script>

<style scoped lang="scss">
.property-card {
  background: #fff;
  border-radius: 5px;
  padding: 15px;

  .property-name {
    font-weight: 600;
    color: #2c5cc5;
  }
}
</style>
